import React from 'react';
import {
    StyledBarBackground,
    StyledBarForeground,
    StyledBarDescriptionContainer,
    StyledBarValue,
    StyledBarDescription,
    StyledValue,
} from './progressbar.style';

export interface IProgressbar {
    value: number;
    base?: number;
    description: string;
    descriptionColor?: string;
    showBase?: boolean;
}

export const Progressbar = ({
    value,
    base = 10,
    description,
    showBase = true,
    descriptionColor,
}: IProgressbar) => {
    const calculatedBarLength = Math.ceil((value * 100) / base);
    let barLength = 100;

    if (calculatedBarLength >= 0 && calculatedBarLength <= 100) {
        barLength = calculatedBarLength;
    }

    return (
        <>
            <StyledBarBackground>
                <StyledBarForeground width={barLength} />
            </StyledBarBackground>
            <StyledBarDescriptionContainer>
                <StyledBarDescription color={descriptionColor}>{description}</StyledBarDescription>
                <StyledBarValue hasBaseValue={showBase}>
                    <span>
                        <StyledValue>{value}</StyledValue>
                        {showBase && ' / ' + base}
                    </span>
                </StyledBarValue>
            </StyledBarDescriptionContainer>
        </>
    );
};
